import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emh-summary-widget__content" }
const _hoisted_2 = { class: "wb-vehicle-tile__price-value" }
const _hoisted_3 = { class: "wb-vehicle-tile__price-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fcis_summary_text = _resolveComponent("fcis-summary-text")!
  const _component_AdditionalData = _resolveComponent("AdditionalData")!
  const _component_fcis_summary_popup = _resolveComponent("fcis-summary-popup")!
  const _component_fcis_summary_widget = _resolveComponent("fcis-summary-widget")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.hostCssClass)
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.t('dcp.sfp.stageCampaign.monthlyPrice.from')), 1),
    _createVNode(_component_fcis_summary_widget, {
      ref: "fcisWidgetEl",
      class: "emh-summary-widget",
      "^environment": _ctx.environment,
      onFcis_summary_quote: _ctx.onFcisQuote,
      onFcis_summary_error: _ctx.onFcisError,
      onViewportEntered: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewportEntered = true))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createVNode(_component_fcis_summary_text, {
              class: "emh-summary-widget__label",
              "^type": 'rate'
            })
          ]),
          _createElementVNode("p", _hoisted_3, [
            _createVNode(_component_fcis_summary_text, {
              class: "emh-summary-widget__label",
              "^type": 'label'
            }),
            _createVNode(_component_fcis_summary_popup, { onFcis_summary_popup_toggle: _ctx.onFcisPopupToggle }, {
              default: _withCtx(() => [
                _createVNode(_component_AdditionalData, {
                  language: _ctx.language,
                  "slot-name": "popup-header",
                  t: _ctx.t,
                  product: _ctx.product
                }, null, 8, ["language", "t", "product"])
              ]),
              _: 1
            }, 8, ["onFcis_summary_popup_toggle"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["^environment", "onFcis_summary_quote", "onFcis_summary_error"])
  ], 2))
}